//#region src/core/i18n/locales/sr.ts
var sr_default = {
	buttons: {
		play: "Pusti",
		pause: "Pauza",
		replay: "Ponovi",
		mute: "Utišaj",
		unmute: "Poništi utišavanje"
	},
	seek: {
		forward: "Premotaj unapred {seconds} sekundi",
		backward: "Premotaj unazad {seconds} sekundi"
	},
	fullscreen: {
		enter: "Režim celog ekrana",
		exit: "Izađi iz režima celog ekrana"
	},
	captions: {
		enable: "Uključi titlove",
		disable: "Isključi titlove"
	},
	pip: {
		enter: "Slika u slici",
		exit: "Izađi iz slike u slici"
	},
	live: {
		playing: "Reprodukcija uživo",
		seekToEdge: "Idi na live",
		badge: "Uživo"
	},
	cast: {
		start: "Počni emitovanje",
		stop: "Zaustavi emitovanje",
		connecting: "Povezivanje"
	},
	airplay: {
		start: "Покрени AirPlay",
		stop: "Заустави AirPlay"
	},
	slider: { seek: "Premotavanje" },
	time: {
		current: "Trenutno vreme",
		duration: "Vreme trajanja",
		remaining: "Preostalo vreme",
		elapsedSuffix: "{duration} proteklog vremena",
		durationSuffix: "{duration} trajanja",
		remainingSuffix: "Preostalo {duration}",
		showElapsed: "Prikaži proteklo vreme, {duration}.",
		showDuration: "Prikaži trajanje, {duration}.",
		showRemaining: "Prikaži preostalo vreme, {duration}.",
		toggleElapsed: "Prebacivanje između proteklog i preostalog vremena.",
		toggleDuration: "Prebacivanje između trajanja i preostalog vremena.",
		position: "{current} od {duration}",
		unknown: "Медијски садржај није учитан, време није познато."
	},
	playback: { rate: "Stopa reprodukcije {rate}" },
	volume: {
		mutedValue: "{percent}, utišano",
		muted: "Utišano",
		label: "Jačina zvuka",
		value: "Jačina zvuka {value}"
	},
	status: {
		captionsOn: "Titlovi uključeni",
		captionsOff: "Titlovi isključeni",
		paused: "Pauzirano",
		playing: "Reprodukuje se",
		fullscreen: "Režim celog ekrana",
		pip: "Slika u slici",
		exitPip: "Izađi iz slike u slici",
		seekedTo: "Premotano na {time}"
	},
	container: { label: "Medija plejer" },
	errors: {
		aborted: "Isključili ste reprodukciju videa.",
		network: "Video se prestao preuzimati zbog greške na mreži.",
		decode: "Reprodukcija videa je zaustavljena zbog greške u formatu ili zbog verzije vašeg pretraživača.",
		source: "Video se ne može reproducirati zbog servera, greške u mreži ili format nije podržan.",
		encrypted: "Medij je šifrovan i nema ključeva za dešifrovanje.",
		unplayable: "Plejer ne podržava ovaj medij.",
		title: "Nešto je pošlo po zlu.",
		unexpected: "Došlo je do greške. Molimo pokušajte ponovo."
	},
	common: {
		empty: "",
		ok: "Zatvori"
	},
	menu: {
		settings: "Podešavanja",
		quality: "Kvalitet",
		audio: "Zvuk",
		default: "Подразумевано",
		speed: "Brzina",
		captions: "Titlovi",
		playbackRate: "Stopa reprodukcije",
		back: "Nazad",
		off: "Isključeno",
		auto: "Automatski",
		autoWithLabel: "Automatski ({label})",
		subtitles: "Titlovi"
	}
};
//#endregion
export { sr_default as default };

//# sourceMappingURL=sr.js.map